(function () {
  'use strict';

  var registry = window.PooleaseSectionScripts = window.PooleaseSectionScripts || {};

  function initSection(section) {
    if (!section || section.dataset.productSpecsReady === 'true') return;
    var groups = Array.prototype.slice.call(
      section.querySelectorAll('[data-specs-group]')
    );
    if (!groups.length) return;
    section.dataset.productSpecsReady = 'true';

    var railItems = section.querySelectorAll('[data-specs-rail-item]');

    var MOBILE_MQ = window.matchMedia('(max-width: 768px)');
    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var n = groups.length;
    var currentIdx = 0;
    var ticking = false;
    var mobileRevealObserver;

    function syncMobileReveals() {
      if (mobileRevealObserver) {
        mobileRevealObserver.disconnect();
        mobileRevealObserver = null;
      }

      section.classList.remove('is-mobile-reveal-ready');
      groups.forEach(function(group) { group.classList.remove('is-revealed'); });
      if (!MOBILE_MQ.matches || reduceMotion) return;

      section.classList.add('is-mobile-reveal-ready');
      if (typeof IntersectionObserver === 'undefined') {
        groups.forEach(function(group) { group.classList.add('is-revealed'); });
        return;
      }

      mobileRevealObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            mobileRevealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' });
      groups.forEach(function(group) { mobileRevealObserver.observe(group); });
    }

    function setActive(idx) {
      if (idx === currentIdx) return;
      currentIdx = idx;
      groups.forEach(function (g, i) {
        var isActive = i === idx;
        g.classList.toggle('product-specs__group--active', isActive);
      });
      railItems.forEach(function (item) {
        var itemIdx = parseInt(item.getAttribute('data-specs-rail-idx'), 10);
        item.classList.toggle('product-specs__rail-item--active', itemIdx === idx);
      });
    }

    function update() {
      ticking = false;
      if (MOBILE_MQ.matches) return;

      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;

      // Active when section is in viewport
      var inView = rect.bottom > 0 && rect.top < vh;
      if (!inView) return;

      // The pinned stage follows continuous native scroll progress. There is
      // no per-group dwell range, scroll snap, or wheel interception. The
      // edge cushion leaves the first and last groups fully readable.
      var scrollable = Math.max(1, rect.height - vh);
      var edgeBuffer = vh * 0.5;
      var travel = Math.max(1, scrollable - edgeBuffer * 2);
      var sp = Math.max(0, Math.min(1, (-rect.top - edgeBuffer) / travel));

      var idx = Math.min(n - 1, Math.round(sp * (n - 1)));
      setActive(idx);
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    // Initial state
    setActive(0);
    syncMobileReveals();

    function onMediaChange() {
      syncMobileReveals();
      currentIdx = -1;
      update();
    }
    MOBILE_MQ.addEventListener('change', onMediaChange);

    if (reduceMotion) {
      // No scroll listener is needed; CSS keeps every group readable.
      section._productSpecsCleanup = function() {
        MOBILE_MQ.removeEventListener('change', onMediaChange);
        if (mobileRevealObserver) mobileRevealObserver.disconnect();
      };
      return;
    }

    function onResize() {
      currentIdx = -1;
      onScroll();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    section._productSpecsCleanup = function() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      MOBILE_MQ.removeEventListener('change', onMediaChange);
      if (mobileRevealObserver) mobileRevealObserver.disconnect();
    };

    update();
  }

  function initAll(root) {
    var scope = root || document;
    var selector = '[data-section-type="product-specs"][data-specs-section]';
    if (scope.matches && scope.matches(selector)) initSection(scope);
    var sections = scope.querySelectorAll ? scope.querySelectorAll(selector) : [];
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (registry.productSpecs) {
    registry.productSpecs(document);
    return;
  }
  registry.productSpecs = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function(event) {
    var selector = '[data-section-type="product-specs"][data-specs-section]';
    var section = event.target.matches(selector) ? event.target : event.target.querySelector(selector);
    if (section && section._productSpecsCleanup) section._productSpecsCleanup();
  });
})();
